export default [
  // 新建/编辑物品
  {
    name: 'task-success',
    component: () => import(/* webpackChunkName: "task-success" */ './task-success.vue'),
  },
];
